import {
  devUsersIds,
} from '../constants';

const isDev = (id) => devUsersIds.includes(Number(id));

export {
  isDev,
};
